import { render, staticRenderFns } from "./TabDisputeInfoPreview.view.vue?vue&type=template&id=7e7447fa&"
import script from "./TabDisputeInfoPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabDisputeInfoPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7447fa')) {
      api.createRecord('7e7447fa', component.options)
    } else {
      api.reload('7e7447fa', component.options)
    }
    module.hot.accept("./TabDisputeInfoPreview.view.vue?vue&type=template&id=7e7447fa&", function () {
      api.rerender('7e7447fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/common/partials/TabDisputeInfoPreview.view.vue"
export default component.exports